import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import { Indent } from "src/uikit"

import DashaLogo from "./assets/dasha-logo.svg"
import MicrosoftLogo from "./assets/microsoft-logo.svg"
import * as S from "./styled"

const AzureNote = ({ json }) => {
  return (
    <S.Container>
      <Indent lg={120} md={80} sm={64} />
      <div className="inner">
        <div className="text">{documentToReactComponents(json)}</div>
        <div className="logos">
          <S.Logo>
            <DashaLogo />
          </S.Logo>
          <S.Logo>
            <MicrosoftLogo />
          </S.Logo>
        </div>
      </div>
    </S.Container>
  )
}

export default AzureNote
